import { Box } from '@mantine/core';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import { useEffect, useRef, useState } from 'react';

interface RevisionLogNoteProps {
  note?: string;
}

/**
 * Renders a revision log note with collapsible content.
 */
export default function RevisionLogNote({ note }: RevisionLogNoteProps) {
  const [expanded, setExpanded] = useState(false);
  const [hasOverflow, setHasOverflow] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = contentRef.current;
    if (!container) {
      /* istanbul ignore next -- explicitly authorized unreachable coverage blocker */
      return;
    }

    setHasOverflow(container.scrollHeight > 200);
  }, [note]);

  return (
    <Box>
      <Box
        ref={contentRef}
        pos="relative"
        className={expanded ? '' : 'line-clamp-[8]'}
        sx={{
          maxHeight: expanded ? 'none' : 200,
          overflow: 'hidden',
          whiteSpace: 'pre-wrap',
          b: { fontWeight: 500 },
        }}
        dangerouslySetInnerHTML={{ __html: note ?? '' }}
      />
      {hasOverflow && (
        <Box
          component="button"
          type="button"
          mt={8}
          p={0}
          sx={{
            border: 'none',
            background: 'transparent',
            fontWeight: 600,
            color: 'var(--mantine-color-red-7)',
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
          }}
          onClick={() => setExpanded((prev) => !prev)}
        >
          {expanded ? 'Zobraziť menej' : 'Zobraziť viac'}
          {expanded ? <IconChevronUp size={16} /> : <IconChevronDown size={16} />}
        </Box>
      )}
    </Box>
  );
}
